import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '../../util';
import { Subscription } from 'rxjs';

import { ActivityService } from '../../services/activity.service';
import { ActivityClassificationService } from '../../services/activity-classification.service';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';
import { UnitService } from '../../services/unit.service';
import { toast } from 'angular2-materialize';

@Component({
	selector: 'app-read-activity',
	templateUrl: './read-activity.component.html',
	styleUrls: ['./read-activity.component.css', '../../app.component.css']
})

export class ReadActivityComponent implements OnInit, OnDestroy {
	allowed: boolean = false;
	permission: any = {};

	activities: any[] = [];


	CHECK_ICON: string = `<i class="small material-icons light-green-text text-darken-1">check_circle</i>`;
	CANCEL_ICON: string = `<i class="small material-icons red-text text-darken-2">cancel</i>`;

	data: Array<any>;
	rows: Array<any> = [];
	columns: Array<any> = [
		{ title: 'Nombre', name: 'name', sort: 'asc' },
		{ title: 'Clasificación', name: 'classification'},
		{ title: 'Valor', name: 'value'},
		{ title: 'Prod', name: 'appliesPrVnta'},
		{ title: 'OdP', name: 'appliesOdP'},
		{ title: 'Acciones', name: 'actionGroup', className:'thCenter', sort: false, actions: { type: 'group', buttons: [
			{ name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
			  styleClass: 'btn-floating btn waves-effect light-green darken-1' },
			{ name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
			  styleClass: 'btn-floating btn waves-effect red darken-2', }
		] } }
	];

	page = 1;
	itemsPerPage = 20;
	maxSize = 5;
	numPages = 1;
	length = 0;
	config: any = {
		paging: true,
		sorting: { columns: this.columns },
		filtering: { filterString: '' },
		api: {
			onEdit: this.onEdit.bind(this),
			onDelete: this.onDelete.bind(this)
		}
	};

	activitySub: Subscription;

	permissions = [];

	constructor(
		private service: ActivityService,
		private activityClassService: ActivityClassificationService,
		private authService: AuthService,
		private unitService: UnitService,
		private permissionService: PermissionService,
		private activatedRoute: ActivatedRoute,
		private router: Router
	) {
        let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
            permissionsSubs.unsubscribe();
            this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
            if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
            else this.allowed = true;
		});
		this.loadActivities();
	}

	ngOnInit() {
	}
	ngOnDestroy() {
		//this.activitySub.unsubscribe();
	}

	loadActivities() {
		/* let acts = JSON.parse(localStorage.activities);
		acts.map(act => {
			this.service.addActivity(act);
		})
		if(1) return console.table(acts); */
		this.activitySub = this.service.getActivities().subscribe(activities => {
			/* localStorage.activities = JSON.stringify(activities.map(({activityClassObj, active, activityClassificationRef, measurementUnitRef, unique={}, ...act}) => {
				return {
					activityClassificationRef: activityClassificationRef.id,
					unique,
					...act
				}
			})); */

			this.activities = [];
			activities.map(activity => {
				activity.appliesPrVnta = activity.appliesPrVnta ? this.CHECK_ICON : this.CANCEL_ICON;
				activity.appliesOdP = activity.appliesOdP ? this.CHECK_ICON : this.CANCEL_ICON;

				let subClass = this.activityClassService.getActivityClassification(activity.activityClassificationRef.id).subscribe(actClass => {
					activity.classification = actClass.name;
					subClass.unsubscribe();
				});

				if(activity.measurementUnitRef){
					//console.log(activity.id, activity.measurementUnitRef.id)
					let subUnit = this.unitService.getUnit(activity.measurementUnitRef.id).subscribe(unit => {
						activity.value += unit ? ` ${unit.symbol}` : '';
						subUnit.unsubscribe();
					});
				}

				this.activities.push(activity)
			});

			if(localStorage.re_act__page){
				this.page = +localStorage.re_act__page;
			}
			this.data = this.activities;
			this.length = this.data.length;
			this.onChangeTable(this.config);
		});
	}

	onCellClick(data: any): any {
		this.router.navigate(['/vw_activity/' + data.row.id]);
	}

    onCreate(){
      if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
      this.router.navigate(['/add_activity']);
    }

	onEdit(data: any) {
		console.log(data.row);
        if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
		this.router.navigate(['/edt_activity/', data.row.id]);
	}

	onDelete(data: any) {
		if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
		if(data.row.fileURL) return toast('Elimine el archivo primero.', 2000);
		this.service.deleteActivity(data.row.id);
	}



	// *************** Table functionality *************** //
	changePage(page: any, data: Array<any> = this.data): Array<any> {
		localStorage.re_act__page = `${page.page}`;
		let start = (page.page - 1) * page.itemsPerPage;
		let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

		return data.slice(start, end);
	}

	changeSort(data: any, config: any): any {
		if (!config.sorting) {
			return data;
		}

		let columns = this.config.sorting.columns;
		let columnName: string;
		let sort: string;

		for (let i = 0; i < columns.length; i++) {
			if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
				columnName = columns[i].name;
				sort = columns[i].sort;
			}
		}

		if (!columnName) {
			return data;
		}

		// simple sorting
		return data.sort((previous: any, current: any) => {
			if (previous[columnName] > current[columnName]) {
				return sort === 'desc' ? -1 : 1;
			} else if (previous[columnName] < current[columnName]) {
				return sort === 'asc' ? -1 : 1;
			}

			return 0;
		});
	}

	changeFilter(data: any, config: any): any {
		let filteredData: Array<any> = data;

		this.columns.forEach((column: any) => {
			if (column.filtering) {
				filteredData = filteredData.filter((item: any) => {
					return item[column.name].match(column.filtering.filterString);
				});
			}
		});

		if (!config.filtering) {
			return filteredData;
		}

		if (config.filtering.columnName) {
			return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
		}

		let tempArray: Array<any> = [];

		filteredData.forEach((item: any) => {
			let flag = false;

			this.columns.forEach((column: any) => {
				if (item[column.name] &&
					item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
					flag = true;
				}
			});

			if (flag) {
				tempArray.push(item);
			}
		});

		filteredData = tempArray;

		return filteredData;
	}

	onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
		if (config.filtering) {
			Object.assign(this.config.filtering, config.filtering);
		}

		if (config.sorting) {
			Object.assign(this.config.sorting, config.sorting);
		}

		let filteredData = this.changeFilter(this.data, this.config);
		let sortedData = this.changeSort(filteredData, this.config);

		this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
		this.length = sortedData.length;
	}

}
